import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import AssetManagementApiService from './AssetManagementApiService'
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';
import { GET_ASSET_AUDIT_REPORT_DETAILS, GET_ASSET_EONE_DETAILS } from 'Store/AssetManagement/AssetEoneDetails/AssetEoneDetailsType';
import { setAssetEoneDetails } from 'Store/AssetManagement/AssetEoneDetails/AssetEoneDetailsAction';


function* getAssetEoneDetailsSaga(req?: any): any {
    try {
        yield put(globalLoaderText("Fetching Details...."));
        let payloadData: IPayload = {
            apiType: apiType.AssetManagement,
            endpoint: `activeasset/getassetdetails/${req.payload}`,
            apiMethod: apiMethod.GET,
            payload: null
        }
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );

        yield put(setAssetEoneDetails(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(globalLoaderText(""));
        yield put(setAssetEoneDetails({}))
    }
}

function* watchAssetEoneDetails() {
    yield takeEvery(GET_ASSET_EONE_DETAILS, getAssetEoneDetailsSaga)
}

export default function* combinedSaga() {
    yield all([
        watchAssetEoneDetails()
    ])
}